import { lensPath, view } from 'ramda';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import ACCOUNT_ACTION_TYPES, {
  DepositsActionTypeIndia,
  FiatBankDetailsActionTypeIndia,
} from 'actionTypes/account';
import { OFFRAMP_ACTION_TYPES } from 'actionTypes/offramp';
import { ONRAMP_ACTION_TYPES } from 'actionTypes/onramp';
import TRADE from 'actionTypes/trade';
import WALLET from 'actionTypes/wallet';
import { addLogsToSentry } from 'helpers/sentry';

const depositActions = [
  ACCOUNT_ACTION_TYPES[FiatBankDetailsActionTypeIndia.GET_FIAT_BANK_DETAILS].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.NEW_DEPOSITS].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.WHITELIST_UPI_ID].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.GENERATE_UPI_PAYMENT_URL].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.CONFIRM_DEPOSITS].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.GET_DEPOSIT_HISTORY].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.GET_WHITELISTED_UPI_IDS].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.CLAIM_DEPOSIT].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.SUBMIT_REFUND_DETAILS].FAIL,
  ACCOUNT_ACTION_TYPES[DepositsActionTypeIndia.GET_REFUND_DETAILS].FAIL,

  OFFRAMP_ACTION_TYPES.FETCH_USER_BANK_DETAILS.FAIL,
  OFFRAMP_ACTION_TYPES.FETCH_USER_UPI_DETAILS.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_BANK_DETAILS_REGISTER_SEND_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_BANK_DETAILS_REGISTER_RESEND_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_BANK_DETAILS_REGISTER_VALIDATE_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_UPI_DETAILS_REGISTER_SEND_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_UPI_DETAILS_REGISTER_RESEND_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_UPI_DETAILS_REGISTER_VALIDATE_OTP.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_BANK_DETAILS_DELETE.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_UPI_DETAILS_DELETE.FAIL,

  ONRAMP_ACTION_TYPES.FETCH_FIAT_DEPOSIT_QUOTES.FAIL,
  WALLET.ADDRESS.FAIL,
  WALLET.CREATE_SIMPLEX_PAYMENT_QUOTE.FAIL,
  WALLET.CREATE_SIMPLEX_PAYMENT_REQUEST.FAIL,
  WALLET.GET_SIMPLEX_SUPPORTED_FIAT_CURRENCIES.FAIL,
  WALLET.ONRAMPER_ORDER_URL.FAIL,
  WALLET.ONRAMPER_CURRENCY_LIST.FAIL,

  WALLET.GET_ONMETA_QOUTE.FAIL,
  WALLET.GET_NEOFI_QUOTE.FAIL,
  WALLET.MUDREX_QUOTE.FAIL,
  WALLET.PENDING_DEPOSITS.FAIL,
  TRADE.GET_FIAT_DEPOSIT_ASSETS.FAIL,
  TRADE.GET_ALPYNE_USDT_QUOTE.FAIL,
  TRADE.GET_CRYPTO_FIAT_CONVERSION.FAIL,
];
const bodyLens = data => view(lensPath(['error', 'response', 'body', 'error']), data);

const depositErrorLogginEpic = (action$, state$) =>
  action$.pipe(
    ofType(...depositActions),
    map(action => {
      const userId = state$.value.user.id!;
      const email = state$.value.user.email!;
      const error = bodyLens(action);
      addLogsToSentry(
        { id: userId, email, error },
        `Deposit Error - ${error?.code} - ${action?.type!}`
      );
    })
  );

export default depositErrorLogginEpic;
